module.exports = __webpack_public_path__ + "SourceCodePro-Bold.ttf?03c11f6b0c0f707075d6483a78824c60";